import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "subheader-block ml-auto demo" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-xl-12" }
const _hoisted_8 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_9 = { class: "panel-container show" }
const _hoisted_10 = { class: "panel-content contents" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-5 contCnt" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-5 contCnt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "subheader col-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, "データロック")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.btnDisable,
          class: "btn btn-primary waves-effect waves-themed"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "fal fa-lock-alt mr-1" }, null, -1),
          _createTextVNode("データロック ")
        ]), 8, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.btnDisable,
          class: "btn btn-primary waves-effect waves-themed"
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "fal fa-lock-open-alt mr-1" }, null, -1),
          _createTextVNode("ロック解除 ")
        ]), 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "対象"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "処理年月", -1)),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.domProcessingDate), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "状態", -1)),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.domStatus), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}